import { FeesTab, AdditionalFees, MonthlyFees } from "models";
import { applicationListConstants } from "store";
import { withResetState } from "store/hocs";

import { feesConstants } from "./fees.constants";

const initialState = {
	applicationId: "",
	error: "",
	feesTab: new FeesTab(),
	additionalFees: new AdditionalFees(),
	monthlyFees: new MonthlyFees(),
};

function fees(state = initialState, action) {
	switch (action.type) {
		case applicationListConstants.RESET_APPLICATION_ENTRY_STATE:
			return {
				...initialState,
			};
		case feesConstants.SEND_FEES_REQUEST:
			return {
				...state,
				values: action.fees,
				loading: true,
			};
		case feesConstants.SEND_FEES_SUCCESS:
			return {
				...state,
				applicationId: action.applicationId,
				loading: false,
			};
		case feesConstants.SEND_FEES_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
			};
		case feesConstants.SET_FEE_PROGRAM:
			return {
				...state,
				feeProgram: action.value,
			};
		case feesConstants.SET_ADDITIONAL_FEE_VALUE:
			return {
				...state,
				additionalFees: {
					...state.additionalFees,
					[action.name]: action.value,
				},
			};
		case feesConstants.SET_MONTHLY_FEE_VALUE:
			return {
				...state,
				monthlyFees: {
					...state.monthlyFees,
					[action.name]: action.value,
				},
			};
		default:
			return state;
	}
}

export default withResetState(
	{ initialState, }
)(fees);